module.exports = __webpack_public_path__ + "img/icon_organization.6511ecf4.svg";